<template lang="html">
  <div class="container mt-5">
    <div class="privacy-header">
      <h1>Privacy - Policy</h1>
    </div>
    <div class="mt-5">
        <h2>About this policy</h2>
        <ThickLine />
        <p>This privacy policy has been compiled to better serve those who are concerned with how their
        ‘Personally identifiable information’ (PII) is being used online. PII, as used in US privacy law
        and information security, is information that can be used on its own or with other information to
        identify, contact, or locate a single person, or to identify an individual in context. Please read our
        privacy policy carefully to get a clear understanding of how we collect, use, protect or otherwise handle
        your Personally Identifiable Information in accordance with our website.</p>
    </div>
    <div class="mt-5">
        <h2>What personal information do we collect from the people that visit our website, blog or app?</h2>
        <ThickLine />
        <p>When ordering or registering on our site, as appropriate, you may be asked to enter your email address, mailing address
        or other details to help you with your experience.
        </p>
    </div>
    <div class="mt-5">
        <h2>When do we collect information?</h2>
        <ThickLine />
        <p>We collect information from you when you place an order, subscribe to a newsletter, respond to a survey, fill out a
        form or enter information on our site.
        </p>
    </div>
    <div class="mt-5">
        <h2>How do we use your information?</h2>
        <ThickLine />
        <p>We may use the information we collect from you when you register, make a purchase, sign up for our newsletter,
        respond to a survey or marketing communication, surf the website, or use certain other site features in the following ways:
        </p>
        <ul>
            <li>To personalize user’s experience and to allow us to deliver the type of content and product offerings in which you
            are most interested.</li>
            <li>To improve our website in order to better serve you.</li>
            <li>To allow us to better service you in responding to your customer service requests.</li>
            <li>To quickly process your transactions.</li>
            <li>To send periodic emails regarding your order or other products and services.</li>
        </ul>
    </div>
    <div class="mt-5">
        <h2>How do we protect visitor information</h2>
        <ThickLine />
        <p>Our website is scanned on a regular basis for security holes and known vulnerabilities in order to make your visit to our site
         as safe as possible.
        </p>
        <p><b>We use regular Malware Scanning.</b></p>
        <p>Your personal information is contained behind secured networks and is only accessible by a limited
        number of persons who have special access rights to such systems, and are required to keep the
        information confidential. In addition, all sensitive/credit information you supply is
        <b> encrypted via Secure Socket Layer (SSL) technology.</b></p>
        <p>We implement a variety of security measures when a user places an order enters, submits, or accesses
         their information to maintain the safety of your personal information.
        </p>
        <p>All <b>transactions</b> are processed through a <b>gateway provider</b> and are not stored or
        processed on our servers.</p>
    </div>
    <div class="mt-5">
        <h2>Do we use cookies?</h2>
        <ThickLine />
        <p><b>Yes.</b> Cookies are small files that a site or its service provider transfers to your
        computer’s hard drive through your Web browser (if you allow) that enables the site’s or service
        provider’s systems to recognize your browser and capture and remember certain information.
        For instance, we use cookies to help us remember and process the items in your shopping cart.
        </p>
        <p>They are also used to help us understand your preferences based on previous or current site activity
         which enables us to provide you with improved services. We also use cookies to help us compile aggregate
          data about site traffic and site interaction so that we can offer better site experiences and tools
          in the future.</p>
          <br/>
        <p><b>We use cookies to:</b></p>
        <ul>
            <li>To personalize user’s experience and to allow us to deliver the type of content and product
            offerings in which you
            are most interested.</li>
            <li>Help remember and process the items in the shopping cart.</li>
            <li>Compile aggregate data about site traffic and site interactions in order to offer better
            site experiences and tools in the future. We may also use trusted third-party services that
            track this information on our behalf.</li>
        </ul>
        <p>You can <b>choose</b> to have your computer warn you each time a cookie is being sent, or you can
        choose to turn off all cookies. You do this through your browser (like Internet Explorer, Chrome,
        Firefox) settings. Each browser is a little different, so look at your browser’s Help menu to
        learn the correct way to modify your cookies.</p>
        <p>If you disable cookies off, some features will be disabled It won’t affect the user’s experience
        that make your site experience more efficient and some of our services will not function properly.</p>
        <p><b>However, you can still place orders.</b></p>
    </div>
    <div class="mt-5">
        <h2>Third-part disclosure</h2>
        <ThickLine />
        <p><b>We do not sell, trade, or otherwise transfer to outside parties your personally identifiable
        information unless we provide users with advance notice.</b>
        </p>
        <p>his does not include website hosting partners and other parties who assist us in operating our
         website, conducting our business, or serving our users, so long as those parties agree to keep
         this information confidential. We may also release information when it’s release is appropriate
         to comply with the law, enforce our site policies, or protect ours or others’ rights, property,
         or safety.
        </p>
        <p>However, <b>non-personally identifiable visitor information</b> may be provided to other parties
        for marketing, advertising, or other uses.</p>
    </div>
    <div class="mt-5">
        <h2>Third-part links</h2>
        <ThickLine />
        <p>Occasionally, at our discretion, we may include or offer third-party products or services on
        our website. These third-party sites have separate and independent privacy policies.
       </p>
       <p> We therefore have no responsibility or liability for the content and activities of these linked sites.
       Nonetheless, we seek to protect the integrity of our site and welcome any feedback about these sites.</p>
    </div>
    <div class="mt-5">
        <h2>Google</h2>
        <ThickLine />
        <p>Google’s advertising requirements can be summed up by
        <a href="https://support.google.com/adwordspolicy/answer/1316548?hl=en"
        target="_blank" rel="noopener noreferrer"> Google’s Advertising Principles. </a>
        They are put in place to provide a positive experience for users.</p>
        <p><b>We use Google AdSense Advertising on our website.</b></p>
        <p>Google, as a third-party vendor, uses cookies to serve ads on our site. Google’s use of the DART
        cookie enables it to serve ads to our users based on previous visits to our site and other sites on
        the Internet. Users may opt-out of the use of the DART cookie by visiting the Google Ad and Content
        Network privacy policy.</p>
        <p><b>We have implemented the following:</b></p>
        <ul>
            <li>Demographics and Interests Reporting</li>
        </ul>
        <p>We along with third-party vendors, such as Google use first-party cookies (such as the Google
            Analytics cookies) and third-party cookies (such as the DoubleClick cookie) or other third-party
            identifiers together to compile data regarding user interactions with ad impressions and other
            ad service functions as they relate to our website.</p>
        <p><b>Opting out</b></p>
        <p>Users can set preferences for how Google advertises to you using the Google Ad Settings page.
        Alternatively, you can opt out by visiting the Network Advertising initiative opt out page or
        permanently using the Google Analytics Opt Out Browser add on.</p>
    </div>
    <div class="mt-5">
        <h2>California Online Privacy Protection Act</h2>
        <ThickLine />
        <p>CalOPPA is the first state law in the nation to require commercial websites and online
        services to post a privacy policy. The law’s reach stretches well beyond California to require a
        person or company in the United States (and conceivably the world) that operates websites collecting
        personally identifiable information from California consumers to post a conspicuous privacy policy
        on its website stating exactly the information being collected and those individuals with whom it
        is being shared, and to comply with this policy. – See more at:
        https://consumercal.org/california-online-privacy-protection-act-caloppa/#sthash.0FdRbT51.dpuf</p>
        <p><b>According to CalOPPA we agree to the following:</b></p>
        <ul>
            <li>Users can visit our site anonymously.</li>
            <li>Once this privacy policy is created, we will add a link to it on our home page or as a
            minimum on the first significant page after entering our website.</li>
            <li>Our Privacy Policy link includes the word ‘Privacy’ and can be easily be found on the
            page specified above.</li>
        </ul>
        <p><b>Users will be notified of any privacy policy changes:</b></p>
        <ul>
            <li>On our Privacy Policy Page</li>
        </ul>
        <p>Users are able to change their personal information:</p>
        <ul>
            <li>By emailing us</li>
            <li>By chatting with us or sending us a ticket</li>
        </ul>
        <p><b>How does our site handle do not track signals?</b></p>
        <p>We honor do not track signals and do not track, plant cookies, or use advertising
        when a Do Not Track (DNT) browser mechanism is in place.</p>
        <p><b>Does our site allow third-party behavioral tracking?</b></p>
        <p>It’s also important to note that we allow third-party behavioral tracking.</p>
        <p><b>COPPA (Children Online Privacy Protection Act)</b></p>
        <p>When it comes to the collection of personal information from children under 13, the
        Children’s Online Privacy Protection Act (COPPA) puts parents in control. The Federal Trade
        Commission, the nation’s consumer protection agency, enforces the COPPA Rule, which spells out
        what operators of websites and online services must do to protect children’s privacy and
        safety online.</p>
        <p><b>We do not specifically market to children under 13.</b></p>
    </div>
    <div class="mt-5">
        <h2>Fair Information Practices</h2>
        <ThickLine />
        <p>The <b>Fair Information Practices Principles</b> form the backbone of privacy law in the United
        States and the concepts they include have played a significant role in the development of
        data protection laws around the globe. Understanding the Fair Information Practice Principles
        and how they should be implemented is critical to comply with the various privacy laws that
        protect personal information.</p>
        <p>In order to be in line with Fair Information Practices we will take the following responsive
        action, should a data breach occur:</p>
        <p><b>We will notify the users via email</b></p>
        <p>Within 7 business days</p>
        <p><b>We will notify the users via in-site notification</b></p>
        <p>Within 1 business day</p>
        <p>We also agree to the Individual Redress Principle, which requires that individuals have a
        right to pursue legally enforceable rights against data collectors and processors who fail to
        adhere to the law. This principle requires not only that individuals have enforceable rights against
        data users, but also that individuals have recourse to courts or government agencies to investigate
        and/or prosecute non-compliance by data processors.</p>
    </div>
    <div class="mt-5">
        <h2>Can Spam Act</h2>
        <ThickLine />
        <p>The CAN–SPAM Act is a law that sets the rules for commercial email, establishes requirements
        for commercial messages, gives recipients the right to have emails stopped from being sent to them,
        and spells out tough penalties for violations.</p>
        <p><b>We collect your email address in order to:</b></p>
        <ul>
            <li>Send information, respond to inquiries, and/or other requests or questions.</li>
            <li>Process orders and to send information and updates pertaining to orders.</li>
            <li>We may also send you additional information related to your product and/or service.</li>
        </ul>
        <p><b>To be in accordance with CAN SPAM we agree to the following:</b></p>
        <ul>
            <li>NOT use false or misleading subjects or email addresses.</li>
            <li>Identify the message as an advertisement in some reasonable way.</li>
            <li>Include the physical address of our business or site headquarters.</li>
            <li>Monitor third-party email marketing services for compliance, if one is used.</li>
            <li>Honor opt-out/unsubscribe requests quickly.</li>
            <li>Allow users to unsubscribe by using the link at the bottom of each email.</li>
        </ul>
        <p><b>If at any time you would like to unsubscribe from receiving future emails, you can:</b></p>
        <ul>
            <li>Follow the instructions at the bottom of each email and we will promptly remove you
            from ALL correspondence.</li>
        </ul>
    </div>
    <div class="mt-5">
        <h2>Online Dispute Resolution for consumers</h2>
        <ThickLine />
        <p>The consumer resident in Europe must be aware that the European Commission has established
        an online platform for alternative dispute resolutions that provides for an out-of-court
        method to solve any dispute related to and stemming from online sale and service contracts.</p>
        <p>As a consequence, if you are a European consumer, you can use such platform for resolving
        any dispute stemming from the online contract entered into with the Owner.</p>
        <p>The platform is available at the following link (https://ec.europa.eu/consumers/odr/).</p>
        <p>The Owner is available for any questions via the email address posted under the Owner’s
        information in this document.</p>
    </div>
    <div class="mt-5">
        <h2>Contacting Us</h2>
        <ThickLine />
        <p>If there are any questions regarding this privacy policy you may contact us using
        the information below.</p>
        <a href="mailto:connect@happyg.care">connect@happyg.care</a>
    </div>
  </div>
</template>

<script>
import ThickLine from '../components/utils/ThickLine'
export default {
  components: {
    ThickLine,
  }
}
</script>

<style lang="scss" scoped>
  .privacy-header {
    min-height: 180px;
    display: flex;
    align-items: center;
  }
</style>
